import { render, staticRenderFns } from "./dictionaryManagement.vue?vue&type=template&id=00680158&scoped=true&"
import script from "./dictionaryManagement.vue?vue&type=script&lang=js&"
export * from "./dictionaryManagement.vue?vue&type=script&lang=js&"
import style0 from "./dictionaryManagement.vue?vue&type=style&index=0&id=00680158&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00680158",
  null
  
)

export default component.exports